import { html } from 'lit';
import { cleanMenuItemsFocus, initMenuItemsFocus, scrollToSelected, } from '../menu-items-state-handler';
import { classMap } from 'lit/directives/class-map.js';
export class SimpleSelectRenderer {
    constructor(sdsSelect) {
        this._sdsMenuOpened = false;
        this.openMenu = () => {
            if (this._sdsSelect.trigger instanceof HTMLElement &&
                this._sdsSelect.contextMenu &&
                !this._sdsSelect.contextMenu.opened &&
                !this._sdsSelect.disabled) {
                this._sdsSelect.contextMenu.maxWidth = `${this._sdsSelect.maxWidth}px`;
                this._sdsSelect.contextMenu.show(this._sdsSelect.trigger);
                this._sdsSelect.addEventListeners();
                initMenuItemsFocus(this._sdsSelect.contextMenu);
                setTimeout(() => scrollToSelected(this._sdsSelect.contextMenu));
                this._sdsSelect.dispatchMenuOpenEvent();
                this._sdsMenuOpened = !this._sdsMenuOpened;
                this._sdsSelect.requestUpdate();
            }
        };
        this.toggleContextMenu = () => {
            this._sdsSelect.contextMenu.opened ? this.hideMenu() : this.openMenu();
        };
        this.handleKeyDown = (event) => {
            var _a;
            if (!this._sdsSelect.disabled &&
                (event.code === 'Space' || event.code === 'ArrowDown') &&
                !((_a = this._sdsSelect.contextMenu) === null || _a === void 0 ? void 0 : _a.opened)) {
                event.preventDefault();
                event.stopPropagation();
                this.openMenu();
            }
        };
        this._sdsSelect = sdsSelect;
    }
    render() {
        var _a;
        return html `
            <div class="sds-simple-select-container">
                <button
                    id="trigger"
                    @click="${this.toggleContextMenu}"
                    @keydown="${this.handleKeyDown}"
                    class="${this.getClasses()}"
                    name="${this._sdsSelect.selectInputValue}"
                    aria-haspopup="listbox"
                    aria-expanded="${this._sdsMenuOpened}"
                    aria-label="${this._sdsSelect.selectInputValue
            ? this._sdsSelect.selectInputValue
            : this._sdsSelect.tooltip}"
                >
                    ${this.renderValue()} ${this.renderArrowIcon()}
                </button>

                <sds-context-menu
                    opened="${(_a = this._sdsSelect.contextMenu) === null || _a === void 0 ? void 0 : _a.opened}"
                    id="simple-select-menu"
                >
                    <slot @slotchange="${this._sdsSelect.onContentChange}"></slot>
                </sds-context-menu>
                ${this._sdsSelect.updateMenuContent()}
            </div>
        `;
    }
    renderValue() {
        this._sdsSelect.selectItemStateHandler(item => {
            if (item.selected) {
                const childElement = item.children[0];
                if (childElement && childElement.getAttribute('name')) {
                    this._sdsSelect.itemIcon = childElement.getAttribute('name');
                }
                else {
                    this._sdsSelect.itemIcon = '';
                }
            }
        });
        if (this._sdsSelect.itemIcon && !this._sdsSelect.onlyIcon) {
            return html `
                <sds-clipped-text basic text="${this._sdsSelect.selectInputValue}">
                    <sds-icon size="16" name="${this._sdsSelect.itemIcon}"></sds-icon>
                </sds-clipped-text>
            `;
        }
        else if (this._sdsSelect.itemIcon && this._sdsSelect.onlyIcon) {
            if (this._sdsSelect.selectInputValue || this._sdsSelect.tooltip) {
                const contentValue = this._sdsSelect.selectInputValue
                    ? this._sdsSelect.selectInputValue
                    : this._sdsSelect.tooltip;
                return html `
                    <sds-tooltip position="up" basic>
                        <sds-icon
                            slot="trigger"
                            size="24"
                            name="${this._sdsSelect.itemIcon}"
                        ></sds-icon>
                        <div slot="text">${contentValue}</div>
                    </sds-tooltip>
                `;
            }
            else {
                return html `
                    <sds-icon
                        slot="trigger"
                        size="24"
                        name="${this._sdsSelect.itemIcon}"
                    ></sds-icon>
                `;
            }
        }
        else {
            return html `<sds-clipped-text
                basic
                text="${this._sdsSelect.selectInputValue}"
            ></sds-clipped-text>`;
        }
    }
    renderArrowIcon() {
        return html ` <sds-icon
            size="24"
            name="arrow_down_small"
            style="${this._sdsMenuOpened ? 'transform: rotate(180deg)' : ''}"
        ></sds-icon>`;
    }
    hideMenu(focusInput = true) {
        var _a;
        if ((_a = this._sdsSelect.contextMenu) === null || _a === void 0 ? void 0 : _a.opened) {
            this._sdsSelect.contextMenu.hide(focusInput);
            this._sdsSelect.removeEventListeners();
            cleanMenuItemsFocus(this._sdsSelect.contextMenu);
            this._sdsSelect.dispatchMenuCloseEvent();
            this._sdsMenuOpened = !this._sdsMenuOpened;
            // Set focused property for styling/state (separate from DOM focus)
            this._sdsSelect.focused = focusInput;
            this._sdsSelect.requestUpdate();
        }
    }
    firstUpdated() {
        if (!this._sdsSelect.onlyIcon) {
            this._sdsSelect.style.maxWidth = `${this._sdsSelect.maxWidth}px`;
        }
    }
    getClasses() {
        return classMap({
            'sds-simple-select': true,
            'sds-simple-select--selected': this._sdsMenuOpened,
            'sds-simple-select--disabled': this._sdsSelect.disabled,
        });
    }
    willUpdate() {
        return;
    }
}
